import React, { useState, useEffect } from 'react';
import OwlCarousel from 'react-owl-carousel2';
import SectionTitle from '../../components/Common/SectionTitle';
import SingleTestimonial from '../../components/Testimonial/SingleTestimonial';
import axios from 'axios';

import quote from '../../assets/img/testimonial/quote.png'; // Fallback image

function Testimonial() {
    const [testimonials, setTestimonials] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch testimonials from the API
    useEffect(() => {
        axios.get('https://yautiktechnology.com/api/feedback/testimonial')
            .then((response) => {
                setTestimonials(response.data);  // Assuming response.data contains the testimonials
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching testimonials:', error);
                setLoading(false);
            });
    }, []);

    const options = {
        items: 3,
        nav: false,
        dots: true,
        margin: 30,
        rewind: false,
        autoplay: false,
        stagePadding: 30,
        loop: true,
        center: false,
        responsive: {
            0: {
                stagePadding: 0,
                items: 1,
                dots: false,
            },
            768: {
                items: 2,
                stagePadding: 0,
                dots: true,
            },
            992: {
                items: 2,
                stagePadding: 0,
            },
            1200: {
                items: 3,
                stagePadding: 0,
            },
            1500: {
                items: 3,
                stagePadding: 0,
            },
        },
    };

    return (
        <React.Fragment>
            <div className="rs-testimonial main-home gray-bg pt-120 pb-120 md-pt-80 md-pb-80">
                <div className="container">
                    <SectionTitle
                        sectionClass="sec-title2 text-center mb-46"
                        subtitleClass="sub-text"
                        subtitle="Testimonial"
                        titleClass="title testi-title"
                        title="What Our Customers Are Saying"
                        effectClass="heading-line"
                    />
                    {loading ? (
                        <p>Loading testimonials...</p>  // Show loading message while fetching data
                    ) : (
                        <OwlCarousel options={options}>
                            {testimonials.map((testimonial) => (
                                <SingleTestimonial
                                    key={testimonial.id}
                                    itemClass="testi-item"
                                    quoteImage={quote}  // Using the same quote image for all testimonials
                                    authorImage={testimonial.imageUrl || quote}  // Use the imageUrl from the API or fallback to quote
                                    Title={testimonial.name}
                                    Designation={testimonial.designation}
                                    Description={testimonial.feedbackText}
                                />
                            ))}
                        </OwlCarousel>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
}

export default Testimonial;
